<template>
  <div class="full-spinner" :style="{'top': topMargin}">
    <v-progress-circular
      indeterminate
      :color="$preloaderColor"
      width="4"
      size="60"
    />
    <div class="full-spinner_text">
      {{ spinnerText }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    spinnerText: {
      type: String,
      default: 'Please wait...'
    },
    topMargin: {
      type: String,
      default: '100px'
    }
  }
}
</script>

<style lang="sass" scoped>
.full-spinner
  @extend %disable-selection
  background: rgba($hwayzWhite, 0.9)
  height: 100vh;
  width: 100%;
  z-index: 9
  display: flex
  flex-flow: column
  justify-content: center
  align-items: center
  position: fixed
  top: 0
  left: 0
  overflow: hidden

  &_text
    font-size: 1.6rem
    margin-top: 2rem
    color: $hwayzLightGreen
</style>
